import createRoute        from '@widesk-ui/tools/createRoute';
import EventWorkflowModel from '@models/website/EventWorkflowModel';

const route = createRoute.dashboardFromModel(
	EventWorkflowModel,
	'EventWorkflowDashboard',
	{
		pathPrefix: '/configuration/:eventWorkflowTypeReference',
	},
);
export default route;
